import { BodySizes } from '@agro-club/agroclub-shared'
import { User } from 'modules/domain/user/types'
import {
  BlockedUserIcon,
  CoordinatorVerifiedUserIcon,
  KeyEntityIcon,
  SecurityVerifiedUserIcon,
  UserHasDealsIcon,
  VerifiedUserIcon,
} from 'views/components/TooltipIcons/TooltipIcons'
import { TruncatedValue } from 'views/components/TruncatedValue/TruncatedValue'
import { UserLink } from 'views/components/UserLink/UserLink'
import { EntityWithIconsWrapper } from 'views/styled/common'

type Props = {
  user: User
  to?: string
  bodySize?: BodySizes
  allowTruncate?: boolean
}

export const UserLinkWithIcons = ({ user, to, allowTruncate = true, bodySize }: Props) => {
  const verified = user.profile?.is_verified
  const statuses = {
    isVerified: verified,
    isVerifiedByCoordinator: !verified && user.profile?.is_verified_by_coordinator,
    isVerifiedBySecurity: !verified && user.profile?.is_verified_by_security,
    hasShippedDeals: user.profile?.has_shipped_deals,
    isSignificant: user.profile?.is_significant,
    deactivated: !user.is_active,
  }
  const userLink = <UserLink user={user} to={to} bodysize={bodySize} />

  return (
    <EntityWithIconsWrapper>
      {allowTruncate ? <TruncatedValue hint={user.profile?.full_name}>{userLink}</TruncatedValue> : userLink}
      <VerifiedUserIcon isVisible={statuses.isVerified} />
      <CoordinatorVerifiedUserIcon isVisible={statuses.isVerifiedByCoordinator} />
      <SecurityVerifiedUserIcon isVisible={statuses.isVerifiedBySecurity} />
      <UserHasDealsIcon isVisible={statuses.hasShippedDeals} />
      <KeyEntityIcon isVisible={statuses.isSignificant} />
      <BlockedUserIcon isVisible={statuses.deactivated} />
    </EntityWithIconsWrapper>
  )
}
